module.exports = __webpack_public_path__ + "img/exins.5d7dfc41.svg";